import ErrorContainer from "./MainContainer"


function ErrorPage(){
    return(
        <ErrorContainer />
    )
}

export default ErrorPage